// @ts-ignore
import * as allIcons from '@ant-design/icons/lib';

import type { MenuDataItem } from '@ant-design/pro-layout';
import NP from 'number-precision'
import React from 'react';
import type { ReactElement } from 'react';
import type { Route } from '@/api/core/model/Connect';
import Url from "url";
import _ from 'lodash';
import moment from 'moment';
import { parse } from 'querystring';
import pathRegexp from 'path-to-regexp';

const urlRegex = /(((^https:(?:\/\/))(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)*.$/;
export const isUrl = (path: string): boolean => urlRegex.test(path);

const urlRegexPrefix = /(http|https):\/\/([\w.]+\/?)*./ig
export const isUrlPrefix = (path: string): boolean => urlRegexPrefix.test(path);

//默认视频文件的封面
export const defaultVideoCoverImgUrl = 'http://panda.api.kefen.site:7400/local-uploads/346/738/568b8818a1f2dfab36daee2b983fe258/568b8818a1f2dfab36daee2b983fe258.jpg?oW=1080&oH=707&originalFilename=Screenshot_20220415_153522.jpg'
export const imgFallback = `data:image/png;base64,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`
const videoUrlRegex: RegExp = /http(s)?:\/\/(.+\/)+.+(\.(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4))/i
const videoFilenameRegex: RegExp = /.(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/i

const imageUrlRegex: RegExp = /http(s)?:\/\/(.+\/)+.+(\.(jpg|png|jpeg|gif|bmp|webp))/i
const imageFilenameRegex: RegExp = /.(jpg|png|jpeg|gif|bmp|webp)$/i


const pdfFilenameRegex: RegExp = /^.+(\.pdf)$/

export const isPdfFilename = (filename: string) => pdfFilenameRegex.test(filename);


export const isVideoUrl = (url: string) => videoUrlRegex.test(url);
export const isVideoFilename = (filename: string) => videoFilenameRegex.test(filename);

export const isImageUrl = (url: string) => imageUrlRegex.test(url);
export const isImageFilename = (filename: string) => imageFilenameRegex.test(filename);

export const sleep = time => {
    return new Promise(resolve => setTimeout(resolve, time));
};



export const isAntDesignPro = (): boolean => {
    if (ANT_DESIGN_PRO_ONLY_DO_NOT_USE_IN_YOUR_PRODUCTION === 'site') {
        return true;
    }
    return window.location.hostname === 'preview.pro.ant.design';
};


// 给官方演示站点用，用于关闭真实开发环境不需要使用的特性
export const isAntDesignProOrDev = (): boolean => {
    const { NODE_ENV } = process.env;
    if (NODE_ENV === 'development') {
        return true;
    }
    return isAntDesignPro();
};

export const getPageQuery = () => parse(window.location.href.split('?')[1]);

export const getRedirectInQuery = () => {
    const params = getPageQuery();
    const { redirect } = params as { redirect: string };
    return redirect;
};

const asAuthorities = (authorities: string[] | string | undefined) => {
    if (!authorities) {
        return undefined;
    }
    return _.isArray(authorities) ? authorities : [authorities];
};

export const getRouteAuthorityByMenu = (path: string, menus: MenuDataItem[]): string[] | undefined => {
    let authorities: string[] | undefined = [];
    for (let i = 0; i < menus.length; i++) {
        const menu = menus[i];
        // match prefix
        if (`${Url.parse(menu.path!).path}/` === `${path}/`) {
            if (menu.authority) {
                return asAuthorities(menu.authority);
            }
        } else if (menu.children) {
            authorities = getRouteAuthorityByMenu(path, menu.children) || authorities;
            if (authorities && authorities.length > 0) {
                return authorities;
            }
        }
    }

    return authorities;
};

export const getRouteAuthorityByRoute = (path: string, routeData: Route[]) => {
    let authorities: string[] | undefined = [];
    routeData.forEach((route) => {
        // match prefix
        if (pathRegexp(`${route.path}/(.*)`).test(`${path}/`)) {
            if (route.authority) {
                authorities = asAuthorities(route.authority);
            }
            // exact match
            if (route.path === path) {
                authorities = asAuthorities(route.authority) || authorities;
            }
            // get children authority recursively
            if (route.routes) {
                authorities = getRouteAuthorityByRoute(path, route.routes) || authorities;
            }
        }
    });
    return authorities;
};

export const getRouteAuthority = (path: string, routeData: Route[], menus: MenuDataItem[] = []) => {
    const authorities1 = getRouteAuthorityByRoute(path, routeData);
    const authorities2 = getRouteAuthorityByMenu(path, menus);

    const authorities = [...(authorities1 || []), ...(authorities2 || [])];
    return authorities.length > 0 ? authorities : undefined;
};

/**
 * 将Objcet 的所有对象进行转换
 * @param obj         转换对象
 * @param transform   转换方法
 */
export const allPropsValueTransformTo = (obj: object, transform: (val: any) => any) => {
    const nObj = {};
    Object.keys(obj).forEach((key) => {
        nObj[key] = transform(obj[key]);
    });
    return nObj;
};

export const renameProp = (oldProp: string, newProp: string, { [oldProp]: old, ...others }) => {
    return {
        [newProp]: old,
        ...others,
    };
};

export const duplicates = (arr: any[]) => {
    const seen = new Set<any>();
    const store = new Array<any>();
    arr.filter((item) => seen.size === seen.add(item).size && !store.includes(item) && store.push(item));
    return store;
};

/**
 * 转换ICON字符串为ICON组件
 */
export const toHump = (name: string) => {
    return name.replace(/-(\w)/g, function (all, letter) {
        return letter.toUpperCase();
    });
};

export const getIconComponentName = (name: string | undefined) => {
    if (name) {
        const v4IconName = toHump(name.replace(name[0], name[0].toUpperCase()));
        if (v4IconName.endsWith('Outlined') || v4IconName.endsWith('Filled') || v4IconName.endsWith('TwoTone')) return v4IconName;
        return `${v4IconName}Outlined`;
    }
    return undefined;
};
/**
 * 转换ICON字符串为ICON组件
 */
export const toIconComponent = (name: string): ReactElement<any, any> | null => {
    if (name) {
        // @ts-ignore
        const NewIcon = allIcons[getIconComponentName(name)];
        if (NewIcon) {
            try {
                return React.createElement(NewIcon);
            } catch (error) {
                console.log(error);
            }
        }
    }
    return null;
};

export const isRunInWeixinBrowser = () => {
    return !!(navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 || typeof navigator['wxuserAgent'] !== 'undefined');
};

export const getFilenameFromContentDisposition = (contentDisposition: string) => {
    const fname = '未知文件名';
    if (!contentDisposition) {
        return fname;
    }
    const p = /^.*filename=(.*);?.*$/;

    const matchArray = contentDisposition.match(p);
    if (matchArray && matchArray.length > 1) {
        return decodeURI(matchArray[1]);
    }
    return fname;
};

/*
String fileName = 'default name';
Pattern p = Pattern.compile('.+filename="(.+?)".*');
String contentDisposition = res.getHeader('Content-Disposition');
if(contentDisposition != null) {
    Matcher m = p.matcher(contentDisposition);
    if(m.find()) {
        fileName = m.group(1);
    }
}*/

export const protocolFileValueHandleFun = (val: string) => {
    let fileName = '';
    const matchDelimiter = val?.match(/\|/);
    const match = val?.match(/(http|https)/);

    if (val === null || val === undefined) {
        fileName = '';
    } else if (matchDelimiter) {
        const metaData: any = val?.split('|').map((v) => decodeURI(v?.split('=')[1]));
        fileName = metaData?.join('，');
    } else if (match && !matchDelimiter) {
        fileName = decodeURI(val?.split('=')[1]);
    } else {
        fileName = val;
    }
    return fileName;
};

export const format = (value: any) => {
    let theTime1: any = parseInt(value, 10); // 分
    let theTime2: any = 0; // 小时
    let theTime3: any = 0; // 天
    if (theTime1 > 60) {
        theTime2 = parseInt((theTime1 / 60) as any, 10);
        theTime1 = parseInt((theTime1 % 60) as any, 10);
        if (theTime2 > 24) {
            //大于24小时
            theTime3 = parseInt((theTime2 / 24) as any, 10);
            theTime2 = parseInt((theTime2 % 24) as any, 10);
        }
    }
    let result = '';
    if (theTime1 > 0) {
        result = '' + parseInt(theTime1, 10) + '分' + result;
    }
    if (theTime2 > 0) {
        result = '' + parseInt(theTime2, 10) + '小时' + result;
    }
    if (theTime3 > 0) {
        result = '' + parseInt(theTime3, 10) + '天' + result;
    }
    return result;
};

/**
 * [fileLengthFormat 格式化文件大小]
 * @param  {[int]} total [文件大小]
 * @param  {[int]} n     [total参数的原始单位如果为Byte，则n设为1，如果为kb，则n设为2，如果为mb，则n设为3，以此类推]
 * @return {[string]}       [带单位的文件大小的字符串]
 */
export const fileLengthFormat = (total, n) => {
    let formatVal = '';
    const len = total / 1024.0;
    if (len > 1000) {
        return fileLengthFormat(len, ++n);
    } else {
        switch (n) {
            case 1:
                formatVal = len.toFixed(2) + 'KB';
                break;
            case 2:
                formatVal = len.toFixed(2) + 'MB';
                break;
            case 3:
                formatVal = len.toFixed(2) + 'GB';
                break;
            case 4:
                formatVal = len.toFixed(2) + 'TB';
                break;
            default:
                break;
        }
        return formatVal;
    }
};

export function isDtFormPropsFunction(func) {
    if (typeof func === 'function') {
        return true;
    }
    if (typeof func === 'string' && func.substring(0, 1) === '@') {
        return func.substring(1);
    }
    if (typeof func === 'string' && func.substring(0, 2) === '{{' && func.substring(func.length - 2, func.length) === '}}') {
        return func.substring(2, func.length - 2);
    }
    return false;
}

// 解析函数字符串值
export const evaluateDtFormString = (string, formData, rootValue) => {
    // eslint-disable-next-line
    return Function(`"use strict";
    const rootValue = ${JSON.stringify(rootValue)};
    const formData = ${JSON.stringify(formData)};
    return (${string})`)();
};

// 默认账期
export const DAY_DATE = moment().format('YYYY-MM-DD HH:mm:ss')


export const formatUploadFileDataStructureFun = (url: string) => {
    if (url === null || url === undefined || '') {
        return;
    }
    const uid = `rv-upload-${+new Date()}-${Math.random() * 10000000000}`;
    // eslint-disable-next-line consistent-return
    return {
        uid,
        name: url?.split('=')[1],
        status: 'done',
        url: url,
    };
};

interface IArr {
    uid: string,
    name: string,
    status: string,
    url: string,
}

export const formatUploadFileDataStructureToUrlsFun = (arr: IArr[]) => {
    if (arr.length > 0) {
        return arr.map(a => ({ url: a.url }))
    }
    return null;
}


type IdataProcessingHelpers = {
    base: (arr: []) => any[]
    baseByCountry: (arr: []) => any[]
    age: (arr: []) => any[]
    sex: (arr: []) => any[]
    generalBases: (arr: []) => any[]
    ageCenters: (arr: []) => any[]
    cooperatorBase: (arr: []) => any[]
    cooperatorAge: (arr: []) => any[]
    cooperatorSex: (arr: []) => any[]
}

export const dataProcessingHelpers: IdataProcessingHelpers = {
    base: (arr: any) => arr?.map(b => ({ type: b.baseName, value: b.pandaNum, baseId: b.baseId })),
    baseByCountry: (arr: any) => {
        return _.chain(arr)
            .groupBy("country")
            .map((value, key,) => {
                return { type: key, value: _.sumBy(value.map(v => v.pandaNum)), baseId: value.map(v => v.baseId).join('') }
            })
            .value()

    },
    age: (arr: any) => arr?.map(b => ({
        type:
            b.agePeriod === 'A' ? '幼年'
                :
                b.agePeriod === 'B' ? '亚成体'
                    :
                    b.agePeriod === 'C' ? '成年'
                        : b.agePeriod === 'D' ? '老年' : '', value: b.pandaNum, agePeriod: b.agePeriod
    })),
    sex: (arr: any) => arr?.map(b => ({ type: b.sex === 'MALE' ? '雄性' : b.sex === null ? '未知' : '雌性', value: b.pandaNum, sex: b.sex })),
    generalBases: (arr: any) => {
        const temp: any[] = []
        arr?.forEach(a => {
            if (a.activitiesNightGoodRatio !== null) {
                temp.push({
                    date: a.entityRecordDateStastring,
                    value: a.mentalStateNightGoodRatio,
                    category: '精神状态好'
                })
            }
            if (a.appetiteNightGoodRatio !== null) {
                temp.push({
                    date: a.entityRecordDateStastring,
                    value: a.appetiteNightGoodRatio,
                    category: '食欲情况好'
                })
            }
            if (a.activitiesNightGoodRatio !== null) {
                temp.push({
                    date: a.entityRecordDateStastring,
                    value: a.activitiesNightGoodRatio,
                    category: '活动情况好'
                })
            }

        })
        return temp
    },
    ageCenters: (arr: any) => {
        const metaData = arr?.map(d => {
            return d.ageDto.detailList.map(t => {
                return {
                    ...t,
                    agePeriod: t.agePeriod === 'A' ? '幼年'
                        :
                        t.agePeriod === 'B' ? '亚成体'
                            :
                            t.agePeriod === 'C' ? '成年'
                                : t.agePeriod === 'D' ? '老年' : '',
                    name: d.staName,
                }
            })
        }).flat()
        return metaData
    },
    cooperatorBase: (arr: any) => {
        const arr_: any = []
        arr?.forEach(element => {
            element?.countryList?.forEach(c => {
                arr_.push({
                    type: c.country,
                    value: c.pandaNum
                })
            })
        });


        const china = arr_.filter(f => f.type === "中国")
        const otherPandaNum: any = _.sumBy(arr_.filter(f => f.type !== "中国"), (o: any) => o.value)


        const cooperatorData = [...china, {
            type: '其它',
            value: otherPandaNum,
        }]

        return cooperatorData
    },
    cooperatorAge: (arr: any) => {
        return arr?.map(b => ({
            type:
                b.agePeriod === 'A' ? '幼年'
                    :
                    b.agePeriod === 'B' ? '亚成体'
                        :
                        b.agePeriod === 'C' ? '成年'
                            : b.agePeriod === 'D' ? '老年' : '', value: b.pandaNum, agePeriod: b.agePeriod
        }))
    },
    cooperatorSex: (arr: any) => {
        return arr?.map(b => ({ type: b.sex === 'MALE' ? '雄性' : b.sex === null ? '未知' : '雌性', value: b.pandaNum, sex: b.sex }))
    },
}


type TcVideoInfo = {
    md5name: string;
    originalFilename: string;
    screenshot: string;
    screenshotName: string;
    tcVideo: string;
    tcVideoName: string;
}


export const getTcVideoInfo = (rawVideoUrl: string): TcVideoInfo => {
    if (!isVideoUrl(rawVideoUrl)) {
        return {
            md5name: rawVideoUrl,
            originalFilename: rawVideoUrl,
            screenshot: defaultVideoCoverImgUrl,
            screenshotName: rawVideoUrl,
            tcVideo: rawVideoUrl,
            tcVideoName: rawVideoUrl,
        };
    }
    const url = new URL(rawVideoUrl);
    const nameIndex = url.pathname.lastIndexOf('/');
    const extIndex = url.pathname.lastIndexOf('.');
    const pathnamePrefix = url.pathname.slice(0, nameIndex);
    const md5name = url.pathname.slice(nameIndex + 1, extIndex);

    //const screenshotName = `${md5name}_sp.jpg`;
    const screenshotName = `${md5name}.jpg`;
    //const tcVideoName = `${md5name}_tc.mp4`;
    const tcVideoName = `${md5name}.mp4`;

    return {
        md5name: md5name,
        originalFilename: url.searchParams.get("originalFilename") || "",
        screenshot: `${url.origin}${pathnamePrefix}/${screenshotName}${url.search}`,
        screenshotName: screenshotName,
        tcVideo: `${url.origin}${pathnamePrefix}/${tcVideoName}${url.search}`,
        tcVideoName: tcVideoName,
    }
}



export const pdfJumpFun = (url: string) => {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
}